import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";



const ViewProduct = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  const { id } = useParams();
  document.title = `View product - ${id} | Vekart`;

  const [viewData, setViewData] = useState(null);
  const [error, setError] = useState(null);
  const productsDatas = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/products/products/`+id);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setViewData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 

      

  useEffect(() => {
    productsDatas();
  }, []);

  if (!viewData) return <div>Loading product details...</div>;

  const mergedImages = [
  viewData.feature_image,
  ...(Array.isArray(viewData.other_images) ? viewData.other_images : [])
];
  const renderDetailRow = (label, value) => (
    <Row className="mb-2">
      <Col md={3} className="fw-bold text-muted">
        {label}:
      </Col>
      <Col md={9} className="text-dark">
        {value || "-"}
      </Col>
    </Row>
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Product" breadcrumbItem={`View product - ${id}`} />

        <Row>
         <Col lg={4} md={4}>
            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <Carousel showThumbs={true} infiniteLoop autoPlay>
                  {mergedImages.map((img, idx) => (
                    <div key={idx}>
                      <img
                        src={imgurl + img.fileurl}
                        alt={`Product Image ${idx}`}
                        className="w-100 h-100"
                      />
                    </div>
                  ))}
                </Carousel>
              </CardBody>
            </Card>
            {viewData.feature_image && (
              <Card className="shadow-sm border-0 mb-4">
                <CardBody>
                  <CardTitle tag="h4" className="mb-3 text-primary">
                    Feature Image
                  </CardTitle>
                  <img
                    src={imgurl + viewData.feature_image.fileurl}
                    alt="Feature"
                    className="img-fluid rounded"
                  />
                </CardBody>
              </Card>
            )}

            {viewData.other_images && viewData.other_images.length > 0 && (
              <Card className="shadow-sm border-0 mb-4">
                <CardBody>
                  <CardTitle tag="h4" className="mb-3 text-primary">
                    Other Images
                  </CardTitle>
                  <Row>
                    {viewData.other_images.map((img, idx) => (
                      <Col md={12} key={idx} className="mb-2">
                        <img
                          src={imgurl + img.fileurl}
                          alt={`Other Image ${idx}`}
                          className="img-fluid rounded"
                        />
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            )}

            {viewData.datasheet && (
              <Card className="shadow-sm border-0 mb-4">
                <CardBody>
                  <CardTitle tag="h4" className="mb-3 text-primary">
                    Uploaded Datasheet
                  </CardTitle>
                  <a
                    href={imgurl + viewData.datasheet.fileurl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download Datasheet
                  </a>
                </CardBody>
              </Card>
            )}
          </Col>
          <Col lg={8} md={8}>
            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Product Information
                </CardTitle>
                {renderDetailRow("Product Name", viewData.product_name)}
                <Row className="mb-2">
                  <Col md={3} className="fw-bold text-muted">
                    Product Description:
                  </Col>
                  <Col md={9} className="text-dark">
                    <div dangerouslySetInnerHTML={{ __html: viewData.product_desc }} />
                  </Col>
                </Row>
                
                
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Product Brand
                </CardTitle>
                <div>{viewData.brands?.brand_sname || "N/A"} </div>
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  General Information
                </CardTitle>
                {renderDetailRow("Product Code", viewData.product_code)}
                {renderDetailRow("Certificate", viewData.certificates?.map(c => c.certificate_name).join(", "))}
                {renderDetailRow("Display Name", viewData.displayname?.displayname || "N/A")}
                {renderDetailRow("Category", viewData.categorys?.categoryname || "N/A")}
                {renderDetailRow("Sub Category", viewData.sub_categorys?.subcategoryname || "N/A")}
                {renderDetailRow("Sub-sub Category", viewData.sub_sub_categorys?.subsub_categoryname || "N/A")}
                {renderDetailRow(
                  "Manufacturer Part No.",
                  viewData.manufacturer_part_no
                )}
                {renderDetailRow(
                  "Minimum Stock Qty Warning",
                  viewData.min_stock_warning
                )}
                {renderDetailRow("MRP (Per Item)", `₹ ${viewData.mrp}`)}
                {renderDetailRow("Reserved Quantity", viewData.reserved_quantity)}
                {renderDetailRow("CGST (%)", `${viewData.cgst_pr}%`)}
                {renderDetailRow("SGST (%)", `${viewData.sgst_pr}%`)}
                {renderDetailRow("IGST (%)", `${viewData.igst_pr}%`)}
                {renderDetailRow(
                  "Purchase Price",
                  `₹ ${viewData.purchase_price}`
                )}
                {renderDetailRow("Loading (%)", `${viewData.loading_pr}%`)}
                {renderDetailRow("Margin (%)", `${viewData.margin_pr}%`)}
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Product Short Description
                </CardTitle>
                <div dangerouslySetInnerHTML={{ __html: viewData.product_sdesc }} />
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Publish Info
                </CardTitle>
                {renderDetailRow("Status", viewData.status)}
                {renderDetailRow("Visibility", viewData.visibility)}
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Feature List
                </CardTitle>
                <div>
                  {viewData.features?.map(f => (
                    renderDetailRow(f.featurename, f.featurename)
          ))}
                </div>
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-3 text-primary">
                  Meta Data
                </CardTitle>
                {renderDetailRow("Meta Title", viewData.meta_title)}
                {renderDetailRow("Meta Keywords", viewData.meta_description)}
                {renderDetailRow("Meta Description", viewData.meta_keywords)}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(ViewProduct);
